// libs
import styled from "@emotion/styled";

// constants
import { BREAKPOINTS } from "shared/styles/base";

export const Container = styled.form`
    width: 260px;
    padding-top: 45px;

    @media screen and (max-width: ${BREAKPOINTS.MOBILE}px) {
        width: 100%;
    }

    .input {
        margin-bottom: 15px;
    }
`;
